import { SkeletonBar } from '@petsmart-ui/sparky';

export function MiniPdpSkeleton() {
    return (
        <div className="mini-pdp-drawer__loading-skeleton" data-testid="mini-pdp-loading-skeleton" aria-hidden="true">
            <div className="mini-pdp-drawer__product-info">
                <SkeletonBar className="mini-pdp-drawer__loading-image" data-testid="mini-pdp-loading-image" />
                <div className="mini-pdp-drawer__product-content">
                    <SkeletonBar className="mini-pdp-drawer__loading-name" data-testid="mini-pdp-loading-name" />
                    <SkeletonBar className="mini-pdp-drawer__loading-price" data-testid="mini-pdp-loading-price" />
                </div>
            </div>
            <div className="mini-pdp-drawer__loading-variants">
                <SkeletonBar
                    className="mini-pdp-drawer__loading-variant-label"
                    data-testid="mini-pdp-loading-variant-label"
                />
                <SkeletonBar
                    className="mini-pdp-drawer__loading-variant-row"
                    data-testid="mini-pdp-loading-variant-row"
                />
            </div>
            <div className="delivery-options mini-pdp-drawer__loading-fulfillment">
                {Array.from({ length: 3 }, (_, index) => (
                    <SkeletonBar
                        key={index}
                        className="mini-pdp-drawer__loading-fulfillment-tile"
                        data-testid="mini-pdp-loading-fulfillment"
                    />
                ))}
            </div>
            <SkeletonBar className="mini-pdp-drawer__loading-add-to-cart" data-testid="mini-pdp-loading-add-to-cart" />
        </div>
    );
}
